var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlay1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 899,
    viewBox: "0 0 1920 899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#44bba4;}.c{clip-path:url(#a);}.d{clip-path:url(#b);}.e{opacity:0.5;fill:url(#c);}.f{opacity:0.27;fill:url(#e);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1920,
    height: 899
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1661.354,
    height: 2164,
    rx: 416,
    transform: "matrix(-0.391, -0.921, 0.921, -0.391, 311.288, 1027.801)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.016,
    y1: 0.459,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#399e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4f46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.214,
    y1: 0.015,
    x2: 0.359,
    y2: 1.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#379b87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050d0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1661.354,
    height: 2164,
    rx: 416,
    transform: "matrix(-0.391, -0.921, 0.921, -0.391, 311.288, 1027.801)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 624.354,
    height: 813,
    rx: 138,
    transform: "matrix(0.438, -0.899, 0.899, 0.438, -621.08, 452.578)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 1661.354,
    height: 2164,
    rx: 416,
    transform: "matrix(-0.391, -0.921, 0.921, -0.391, 1170.143, 615.801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay1);
export default __webpack_public_path__ + "static/media/overlay1.6a50995d21707083e4ae544668b9e1f6.svg";
export { ForwardRef as ReactComponent };